import React, { useEffect, useRef, useState } from "react";
import {
  NavItem,
  NavSection,
  StyledLink,
  ButtonSpecial2,
  SocialMediaContainer,
  GiftIcon,
  ButtonsContainer,
  UserIcon,
  ButtonWallet,
  UserMenuContainer,
  UserIconContainer,
  FeaturedContainer,
  FeaturedCard,
  FeaturedImg,
} from "./NavbarElements";
import BotonCasino from "../../assets/images/botones-menu/imgcasino.png";
import BotonCv from "../../assets/images/botones-menu/imgcv.png";
import BotonDeportes from "../../assets/images/botones-menu/imgdeporte.png";
import BotonHipismo from "../../assets/images/botones-menu/imghipismo.png";
import BotonPoker from "../../assets/images/botones-menu/imgpoker.png";
import BotonVr from "../../assets/images/botones-menu/imgvr.png";
import BotonEsports from "../../assets/images/botones-menu/console.png";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  comprobarTiempoInactivo,
  formatCurrency,
  toLocale,
} from "../../utils/tools";
import {
  selectCurrency,
  selectId,
  selectLogged,
  selectToken,
  selectUser,
  setNewToken,
  updateBalance,
  selectFoto,
  selectDetectedCountry,
} from "../../features/user/userSlice";
import { setShowUserBonos } from "../../features/modals/modalsSlice";
import { selectHayNotificaciones } from "../../features/notifications/notificationsSlide";
import axios from "axios";
import UserMenu from "../../components/userMenu";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Dropdown from "../../components/common/Dropdown";
import { API_URL } from "../../const/api";
import DiscountModalUse from "../../components/bonos2/DisconutModalUse";
import {
  selectLimites,
  setLimites,
} from "../../features/limitaciones/limitacionesSlice";

const icons = [
  BotonDeportes,
  BotonHipismo,
  BotonVr,
  BotonEsports,
  BotonCasino,
  BotonCv,
];
let useClickOutside = (handler) => {
  let domNode = useRef();
  useEffect(() => {
    if (!domNode.current) return;
    let clickHandler = (event) => {
      if (!domNode.current.contains(event.target)) {
        handler();
      }
    };
    document.addEventListener("mousedown", clickHandler);
    return () => document.removeEventListener("mousedown", clickHandler);
  });
  return domNode;
};

const NavSectionComp = ({
  saldoTotal,
  clicked,
  setClicked,
  handleModals,
  handleNavItems,
}) => {
  const user = useSelector(selectUser);
  const isLoged = useSelector(selectLogged);
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const moneda = useSelector(selectCurrency);
  const hayNotificaciones = useSelector(selectHayNotificaciones);
  const [isActiveImage, setIsActiveImage] = useState(false);
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const urlImage = "https://notificaciones.betsfactory.co/img_pp/";
  const fotoPerfil = useSelector(selectFoto);
  const limitaciones = useSelector(selectLimites);
  const detectedCountry = useSelector(selectDetectedCountry);

  let domNode = useClickOutside(() => {
    setShowUserMenu(false);
  });

  const handleShowUserMenu = () => {
    setIsActiveImage(!isActiveImage);
    setShowUserMenu(!showUserMenu);
    if (isLoged) {
      // onClick on desktop
      const loadData = async () => {
        const res = await axios.post(API_URL + "actualizarMonto", {
          token,
          id_uo,
        });
        dispatch(setNewToken(res.data.token));
        if (res.data.status === 1) {
          const {
            saldo_juego,
            saldo_retiro,
            saldo_bonos,
            validacion_documento,
            personalDocument,
            verified,
          } = res.data.response;
          dispatch(
            updateBalance({
              saldo_juego,
              saldo_retiro,
              saldo_bonos,
              validacion_documento,
              personalDocument,
              verified,
            })
          );
        }
      };

      const getLimitaciones = async () => {
        let body = { id_uo, token };
        try {
          const res = await axios.post(API_URL + "getLimitaciones", body);
          console.log("navSection", res);
          if (res.data.response !== null) {
            dispatch(setLimites(res.data.response));
            const fecha_config = res.data.response.fecha_config;
            const tiempo_inactivo = res.data.response.tiempo_inactivo;

            //validamos si se cumplio el tiempo de inactividad
            if (
              tiempo_inactivo > 0 &&
              fecha_config &&
              comprobarTiempoInactivo(fecha_config)
            ) {
              // se cumplio el tiempo de inactividad y lo seteamos a 0
              body = {
                ...body,
                ...limitaciones,
                tiempo_inactivo: 0,
                fecha_config: null,
              };
              const res = await axios.post(API_URL + "setLimitaciones", body);
              if (res.data.response === "ok") {
                dispatch(
                  setLimites({
                    ...limitaciones,
                    tiempo_inactivo: 0,
                    fecha_config: null,
                  })
                );
              }
            }
          }
        } catch (error) {
          //console.log(error);
        }
      };

      loadData();
      getLimitaciones();
    }
  };

  const getUrlNav = (url) =>
    (url === "header.link-2.url" || url === "header.link-6.url") && !isLoged
      ? "#"
      : t(url);

  return (
    <NavSection className={clicked ? "active" : null}>
      {icons.map((item, key) => (
        <NavItem
          className="btn-1"
          key={key}
          onClick={() => handleNavItems(`header.link-${key + 1}.url`)}
        >
          <StyledLink to={getUrlNav(`header.link-${key + 1}.url`)}>
            <img className="img-fluid" src={item} alt=""></img>
            <span>{t(`header.link-${key + 1}.title`)}</span>
          </StyledLink>
        </NavItem>
      ))}

      {detectedCountry !== "PE" && (
        <NavItem
          className="btn-1"
          onClick={() => handleNavItems(`header.link-7.url`)}
        >
          <StyledLink to={getUrlNav(`header.link-7.url`)}>
            <img className="img-fluid" src={BotonPoker} alt=""></img>
            <span>{t(`header.link-7.title`)}</span>
          </StyledLink>
        </NavItem>
      )}

      {/* <NavItem
        className={isLoged ? "loged spacemanDesk" : "spacemanDesk"}
        onClick={() => handleNavItems("/slots")}
      >
        <div className="content_spaceman">
          <div className="badge pulsate">NEW</div>
        </div>

        <StyledLink to={`${t('header.link-4.url')}/?game=spaceman&prov=pragmatic`}>
          <img src={spacemanIcon} alt=''/> <span>SPACEMAN</span>
        </StyledLink>
      </NavItem> */}

      {/* <NavItem
        className={isLoged ? "loged" : null}
        onClick={() => dispatch(setShowUserBonos(true))}
      >
        <StyledLink to="#">
          <GiftIcon />
          <span className="icon-promotion">{t("header.promotions.title")}</span>
        </StyledLink>
      </NavItem> */}
      {!isLoged ? (
        <ButtonsContainer>
          <ButtonSpecial2
            bg="primary"
            onClick={() => handleModals("register", true)}
          >
            <span>{t("header.btn-register")}</span>
          </ButtonSpecial2>
          <ButtonSpecial2 onClick={() => handleModals("login", true)}>
            <span>{t("header.btn-login")}</span>
          </ButtonSpecial2>
        </ButtonsContainer>
      ) : (
        <ButtonsContainer>
          <ButtonSpecial2
            bg="primary"
            onClick={() => handleModals("deposit", true)}
            className={isLoged ? "loged" : null}
          >
            <span>{t("header.btn-deposit")}</span>
          </ButtonSpecial2>

          <ButtonSpecial2
            onClick={() => handleModals("withdraw", true)}
            className={isLoged ? "loged" : null}
          >
            <span>{t("header.btn-withdraw")}</span>
          </ButtonSpecial2>

          <ButtonWallet className={isLoged ? "loged" : null}>
            <span>
              <WalletIcon />
              <span>
                {formatCurrency(moneda, user)}{" "}
                {toLocale(parseFloat(saldoTotal))}
              </span>
            </span>
          </ButtonWallet>
          <UserMenuContainer>
            <UserIconContainer>
              {hayNotificaciones && <span className="new"></span>}
              {fotoPerfil ? (
                <img
                  onClick={handleShowUserMenu}
                  src={urlImage + fotoPerfil}
                  alt=""
                />
              ) : (
                <UserIcon onClick={handleShowUserMenu} className="glow" />
              )}
            </UserIconContainer>
            <UserMenu
              showUserMenu={showUserMenu}
              handleShowUserMenu={handleShowUserMenu}
              refer={domNode}
              isActiveImage={isActiveImage}
            />
          </UserMenuContainer>
        </ButtonsContainer>
      )}
      <SocialMediaContainer>
        {isLoged && (
          <div className="btns">
            <ButtonSpecial2
              bg="primary"
              onClick={() => {
                setClicked(false);
                handleModals("deposit", true);
              }}
            >
              {t("header.btn-deposit")}
            </ButtonSpecial2>

            <ButtonSpecial2
              onClick={() => {
                setClicked(false);
                handleModals("withdraw", true);
              }}
            >
              {t("header.btn-withdraw")}
            </ButtonSpecial2>
          </div>
        )}
        <Dropdown />
      </SocialMediaContainer>
      <DiscountModalUse />
    </NavSection>
  );
};

export default NavSectionComp;
